import React, { useEffect, useState } from 'react'

import toast from 'react-hot-toast';
import { getDashboardDataApi } from '../../apiHelper/authService';
import SalesReport from './SalesReport';
import ShipmentStatistics from './ShipmentStatistics';
import OrderDetails from './OrderDetails';
import ContainerDetails from './ContainerDetails';


const DashboardLayer = () => {

    const [loading, setLoading] = useState(false)
    const [dashboardData, setDashboardData] = useState([])
    const [selectedDate, setSelectedDate] = useState("");
    const today = new Date().toISOString().split("T")[0];
    const formattedDate = selectedDate
        ? new Date(selectedDate + "T00:00:00").toISOString()
        : "";


    const getDashboardData = async () => {
        setLoading(true);



        // const toastId = toast.loading("Fetching Dashboard Data...");

        try {
            const res = await getDashboardDataApi({ formattedDate });

            setDashboardData(res?.data)

            // toast.success("Dashboard data fetched successfully!", { id: toastId });
        } catch (err) {
            console.error("Fetch Error:", err);

            // toast.error(
            //     err?.message || "Something went wrong while fetching categories.",
            //     { id: toastId }
            // );
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {

        getDashboardData()


    }, [selectedDate])

    const shipOrderStatus = dashboardData?.[0]?.shipment_order_status_tracking
    const shipTypeTrack = dashboardData?.[0]?.shipment_type_tracking
    const umbrellaManage = dashboardData?.[0]?.umbrella_management_tracking



 

    // console.log(shipment_order_status_tracking)



    const handleClear = () => {
        setSelectedDate("");
    };


    return (
      <>
        {/* <SalesData dashboardData={dashboardData} /> */}

        <section className="row gy-4 ">
          {/* <Containers /> */}
          {/* <Support /> */}
          {loading ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height : "80vh"
              }}
            >
              <div
                className="spinner-border"
                role="status"
                style={{
                  color: "#243E85",
                  width: "2rem",
                  height: "2rem",
                  borderWidth: "0.3em",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              <SalesReport dashboardData={dashboardData} />
              <ShipmentStatistics shipTypeTrack={shipTypeTrack} />
              <OrderDetails
                dashboardData={dashboardData}
                shipOrderStatus={shipOrderStatus}
              />
              <ContainerDetails umbrellaManage={umbrellaManage} />
            </>
          )}
        </section>
      </>
    );
}

export default DashboardLayer